export default __webpack_public_path__ + "media/resources1.745e65c3.png";